import { ClipboardButton as BaseClipboardButton } from "../vendor/ClipboardButton/index.js";

export type ClipboardButtonProps = {
  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;

  /**
   * Whether the button is disabled
   */
  disabled?: boolean | undefined;

  /**
   * The text to copy to the clipboard.
   */
  value: string;
};

/**
 * A `ClipboardButton` copies text to the clipboard. It can be used to copy any text value, e.g. a code snippet, a URL, or any arbitrary text.
 *
 * @param props
 * @example
 * ```tsx
 * import { ClipboardButton } from "@netlify/sdk/ui/react/components";
 *
 * <ClipboardButton value="https://example.com" />
 */
export const ClipboardButton = (props: ClipboardButtonProps) => (
  <BaseClipboardButton icon {...props} />
);
